import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { Button } from "@components/Button";
import { Text } from "@components/Text";
import { COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";

const Container = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 16px;
  background: linear-gradient(181deg, #fff 50%, #e9fff9 99.52%);
`;

const ContainerFileName = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ContainerDescription = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
`;

const ContainerDescriptionItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
`;

const ContainerCampaign = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const PopoverItem = ({
  $item,
  $handleGetDeviceByCampaignId = () => undefined,
}) => {
  const duration = _.get($item, ["duration"], "-");
  const campaignName = _.get($item, ["campaignName"], "-");
  const campaignId = _.get($item, ["campaignId"]);

  const mediaName = _.get($item, ["mediaName"], "-");
  const startTime = _.get($item, ["startTime"], "-");
  const endTime = _.get($item, ["endTime"], "-");
  const mediaId = _.get($item, ["mediaId"], "-");

  return (
    <Container>
      <ContainerFileName>
        <ContainerCampaign>
          <Text fontSize="14px" fontWeight="400">
            Campaign
          </Text>
          <Button
            disabled={_.isNil($item)}
            onClick={() => $handleGetDeviceByCampaignId({ id: campaignId })}
            color={COLOR_GREEN}
            fontColor={COLOR_WHITE}
            fontSize="14px"
            padding="2px 8px"
          >
            Devices
          </Button>
        </ContainerCampaign>
        <Text fontSize="14px" fontWeight="600">
          {campaignName}
        </Text>
      </ContainerFileName>

      <ContainerFileName>
        <Text fontSize="14px" fontWeight="400">
          File Name
        </Text>
        <Text fontSize="14px" fontWeight="600">
          {mediaName}
        </Text>
      </ContainerFileName>
      <ContainerDescription>
        <ContainerDescriptionItem>
          <Text fontSize="14px" fontWeight="400">
            Duration(s)
          </Text>
          <Text fontSize="14px" fontWeight="600">
            {duration}
          </Text>
        </ContainerDescriptionItem>
        <ContainerDescriptionItem>
          <Text fontSize="14px" fontWeight="400">
            Start Time
          </Text>
          <Text fontSize="14px" fontWeight="600">
            {startTime}
          </Text>
        </ContainerDescriptionItem>
        <ContainerDescriptionItem>
          <Text fontSize="14px" fontWeight="400">
            End Time
          </Text>
          <Text fontSize="14px" fontWeight="600">
            {endTime}
          </Text>
        </ContainerDescriptionItem>
      </ContainerDescription>
    </Container>
  );
};
